module.exports = __webpack_public_path__ + "img/kort-18.1914a36b.jpg";